import {
  takeEvery,
  call,
  put,
  select,
  race,
  take,
  fork,
} from 'redux-saga/effects';

import * as confirmUrgentVisit from '../requests/confirm-visit-urgent-req';
import * as verifyCouponAvailable from '../../healthboard/requests/coupon-verification-req';
import * as couponPriceCalculation from '../../healthboard/requests/coupon-price-calculation-req';
import * as paymentOrder from '../../healthboard/requests/payment-order-req';
import { redirectToSummary } from '../../../utils/appointments/redirect-utils';
import {
  selectProgressCareUserId,
  selectUrgentAppointmentId,
} from '../selectors';
import * as successUI from '../../ui/success';
import * as errorUI from '../../ui/error';

export function* handlePriceCalculations() {
  const { success } = yield race({
    success: take(couponPriceCalculation.actions.succeed),
    error: take([
      couponPriceCalculation.actions.rejected,
      couponPriceCalculation.actions.errorEncountered,
    ]),
  });

  if (success) {
    yield put(
      successUI.actions.update({
        id: 'appointment.payment.couponCodeAutomatic',
      }),
    );
  } else {
    yield put(errorUI.actions.update({ id: 'errors.common' }));
  }
}

function* handleRedirectFreePayment({ payload }) {
  const { amount } = { ...payload };
  if (!amount) yield call(redirectToSummary);
}

function* handleProceedStepUrgentVisit({ payload }) {
  const { copay, id } = { ...payload };
  const userId = yield select(selectProgressCareUserId);

  if (!copay) {
    yield call(redirectToSummary);
  } else {
    yield put(
      verifyCouponAvailable.actions.send({
        userId,
        appointmentId: id,
      }),
    );
  }
}

function* verifyCouponUrgentVisit({ payload }) {
  const { automaticCouponAvailable } = { ...payload };
  const appointmentId = yield select(selectUrgentAppointmentId);
  if (automaticCouponAvailable) {
    yield put(couponPriceCalculation.actions.send({ appointmentId }));

    yield fork(handlePriceCalculations);
  }
}

export function* couponUrgentVisit() {
  yield takeEvery(
    [verifyCouponAvailable.actions.succeed],
    verifyCouponUrgentVisit,
  );

  yield takeEvery(
    [confirmUrgentVisit.actions.succeed],
    handleProceedStepUrgentVisit,
  );

  yield takeEvery([paymentOrder.actions.succeed], handleRedirectFreePayment);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/paymentUrgentVisit.js